<mat-dialog-actions>
  @if (buttons.secondary) {
    <button
      size="small"
      mat-raised-button
      [mat-dialog-close]="buttons.secondary.choice">
      {{ buttons.secondary.labelKey | translate }}
    </button>
  }

  @if (buttons.primary) {
    <button
      mat-raised-button
      color="primary"
      size="small"
      [mat-dialog-close]="buttons.primary.choice">
      {{ buttons.primary.labelKey | translate }}
    </button>
  }
</mat-dialog-actions>
